module.exports = __webpack_public_path__ + "img/Nav_check.32944c46.svg";